<template>
    <div class="gongxinhomepage gongxinhomepage-box">
        <div class="gongxinhomepage-logo">
            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/logo_h5%402x.png" alt />
        </div>
        <div class="gongxinhomepage-banner">
            <banner class="banner-con" :imgList="homedata.imgList" />
        </div>
        <div class="gongxinhomepage-plate">
            <ul>
                <li @click="plateJump(plate.name)" v-for="(plate, index) in homedata.plateList" :key="index">
                    <img :src="plate.url" alt />
                    <span>{{plate.name}}</span>
                </li>
            </ul>
        </div>
        <div class="gongxinhomepage-course">
            <h3 class="gongxinhomepage-course-title">培训课程 · 轻松通关</h3>
            <div @click="goCoursePayPage(item.id,item.seq,item.status)" class="gongxinhomepage-course-content" v-for="(item,index) in trainArr" :key="index">
                <div class="content-img" >
                    <img :src="item.picUrl ? item.picUrl : ''" alt />
                </div>
                <div class="course-Info">
                    <h4 class="Info-title">{{item.name}}</h4>
                    <p class="Info-time" v-if="item.validityType === 1">
                        上课时间：长期有效
                    </p>
                    <p class="Info-time" v-else-if="item.validityType === 2">
                        {{item.startTime | standardTime}}-{{item.endTime | standardTime}}
                    </p>
                    <p class="Info-time" v-if="item.validityType === 4">
                        上课时间：报名后{{item.days}}天内有效
                    </p>
                    <p class="price">
                        <span class="discountPrice" v-if="!item.isFree">¥</span>
                        <span class="discountPrice-num">{{item.isFree?'免费':item.salePrice}}</span>
                        <span class="originalCost" v-if="!item.isFree&&item.basePrice">原价¥{{item.basePrice}}</span>
                    </p>
                </div>
            </div>
        </div>
        <!-- v-if="configLive" -->
        <div v-if="configLive"  class="gongxinhomepage-live">
            <div class="gongxinhomepage-live-title">
                <h3 class="live-title-name">最近直播 · 名师优选</h3>
                <p class="live-title-more" @click="plateJump('直播专区')">
                    <span>更多</span>
                    <img src="../asset/images/shouye/more@2x.png" alt />
                </p>
            </div>
            <div class="liveList">
                <ul>
                    <li @click="goliveDetail(liveInfo)">
                        <h4 class="livetitle">{{liveInfo.title}}</h4>
                        <p class="liveInfo">
                            <span class="live-time">{{liveInfo.beginTime}}</span>
                            <span v-if="islive" class="live-btn" @click="plateJump('直播专区')">进入直播</span>
                            <span v-else class="live-btn-no">未开始</span>
                        </p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="line"></div>
        <div class="gongxinhomepage-Ai">
            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/zhengshu_h5%402x.png" alt="">
            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/Ai.png" alt />
        </div>
        <div class="gongxinhomepage-expert">
            <div class="expert-title">
                <img src="../asset/images/shouye/jinpai@2x.png" alt />
            </div>
            <div class="expert-list">
                <ul>
                    <li v-for="(expert, index) in expertList1" :key="index">
                        <div class="expert-photo">
                            <img :src="expert.photo" alt="">
                        </div>
                        <div class="expert-info">
                            <p class="info-title">
                                <span class="info-title-name">{{expert.name}}</span>
                                <span class="info-title-title">{{expert.title}}</span>
                            </p>
                            <p class="info-content">{{expert.info}}</p>
                        </div>
                    </li>
                </ul>
                <div v-if="showall" class="expert-more">
                    <span @click="getMoreExpert()">查看更多 <img src="../asset/images/shouye/gengduo@2x.png" alt=""></span>
                </div>
            </div>
        </div>
        <!-- 在线问答 -->
        <div class="answershow">
            <van-popup  v-model="answershow">
                <div class="answerpop">
                    <h4 class="answertitle">联系我们</h4>
                    <div class="answerImg">
                        <img class="smallimg topimg" src="../asset/images/shouye/callmetop@2x.png" alt="">
                        <img class="bigimg" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/answer.jpg" alt="">
                        <img class="smallimg bottomimg" src="../asset/images/shouye/callmebottom@2x.png" alt="">
                    </div>
                    <p class="answerText">咨询电话:400-888-8888</p>
                    <p class="answerText">或扫描二维码关注公众号进行咨询</p>
                </div>
            </van-popup>
        </div>
        <saas-nsr-footer />
    </div>
</template>

<script>
// import banner from '../../home/block/banner.vue';
import Clipboard from 'clipboard';
import { Toast } from 'vant';
import homedata from '../asset/js/mock.js';
export default {
    name: "gongxinHomepage",
    data() {
        return {
            configLive: false,
            islive: false,
            homedata: homedata,
            // liveshow: false,
            answershow: false,
            windowurl: '',
            trainInfo: {},
            showall: true,
            expertList1: [],
            token: null,
            liveInfo: {},
            practiceTestId: null,
            goodsId:null,
            trainArr:[
                {
                    "basePrice": 0,
                    "categoryCode": "string",
                    "categoryId": 0,
                    "days": 0,
                    "endTime": "2021-07-14T11:57:02.277Z",
                    "goodsCategoryName": "string",
                    "goodsType": 0,
                    "goodsTypeName": "string",
                    "id": 0,
                    "isFree": 0,
                    "name": "string",
                    "offTime": "2021-07-14T11:57:02.277Z",
                    "onTime": "2021-07-14T11:57:02.277Z",
                    "picUrl": "string",
                    "referId": 0,
                    "saleCount": 0,
                    "salePrice": 0,
                    "seq": 0,
                    "startTime": "2021-07-14T11:57:02.277Z",
                    "status": 0,
                    "statusName": "string",
                    "trainPicUrl": "string",
                    "tryWatch": 0,
                    "validityType": 0,
                    "visibleRange": 0
                }
            ],

        };
    },
    components: {
        // banner,
    },
    filters: {
        standardTime(val) {
            if (val) {
                return val.split(' ')[0].split('-').join('/')
            } else {
                return ""
            }
        },
    },
    methods: {
        //  时间转换
        formatime(val) {
            let mouth = val? val.split(' ')[0].split('-')[1] :'';
            let day = val ? val.split(' ')[0].split('-')[2]:'';
            return mouth+'月'+day+'日';
        },
        goliveDetail(item) {
            if(this.token){ 
                let u = navigator.userAgent;
                let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                let ua = window.navigator.userAgent.toLowerCase();
                if (isiOS && ua.match(/MicroMessenger/i) == 'micromessenger') {
                    this.$router.push({
                        path: '/liveSkip',
                        }) 
                } else {
                    this.$router.push({
                        path: '/watchLive',
                        query: {
                            type: '1',
                            roomId: item.id,
                            title:  encodeURIComponent(item.title),
                        }
                    }) 
                }                 
            }  else {
                this.$router.push({
                    path: '/login',
                })
            }
        },
        goCoursePayPage(id,type,status) {
            // this.$router.push({path: '/gongxin_coursePay'})
            if(type==1){
                sessionStorage.setItem('courserPayId', id)
                sessionStorage.setItem('courserPayStatus', status)
                this.$router.push({
                    path:'/gongxin_coursePay',
                })
            }else{
                sessionStorage.setItem('secondCourserPayId', id)
                sessionStorage.setItem('secondCourserPayStatus', status)
                this.$router.push({
                    path:'/second_CoursePay',
                })
            }
        },
        // copyliveUrl() {
        //     let txt = this.windowurl
        //     let clipboard = new Clipboard('.popbtn', {
        //         text: function () {
        //             return txt;
        //         }
        //     })
        //     clipboard.on('success', e => {
        //         Toast.success({message: '复制成功', duration: 1000});
        //         // 释放内存
        //         clipboard.destroy();
        //         // this.liveshow = false;
        //     })
        //     clipboard.on('error', e => {
        //         Toast.fail({message: '复制成功', duration: 1000});
        //         clipboard.destroy();
        //         this.liveshow = false;
        //     })
        // },
        // 跳转到模拟考试训练营详情页
        goPracticeTest(id){
            let params = {
                goodsId: id
            }
            this.$api.home.findExamTrain({params}).then((data) => {
                this.practiceTestId = data.data;
            })
        },
        checkUserCanByGoods(){ //查看商品是否购买；
              let params = {
               goodsId:this.goodsId
            }
             this.$api.home.checkUserCanByGoods({params}).then(data =>{
                 this.isStudy = data.data;
                 if(data.data == true){
                     this.$toast("您尚未购买课程，先去购买课程吧");
                     this.goCoursePayPage()
                 }else {
                     this.findUserTrain();
                 }
            })
        },
        findUserTrain(){
            let params = {
                //列表
                trainId: this.practiceTestId
            };
            return this.$api.training.findUserTrain({ params }).then(res => {
                    if(res.success){
                        this.$router.push({
                            path: '/learning/Details',
                            query: {
                                id: this.practiceTestId,
                            }
                        })
                    }
                })
        },
        async plateJump(name){
            if(['考试中心', '个人测评'].includes(name)){
                if(this.token){
                    if(name === '考试中心'){
                        // this.checkUserCanByGoods()
                        this.$router.push({
                            path: '/learning',
                            query:{
                                isExam:true
                            }
                        })
                    }
                    name === '个人测评' ? this.$router.push({
                        path: '/evaluation',
                    }) : null;
                } else {
                    this.$router.push({
                        path: '/login',
                    })
                }
            } else if(name === '直播专区'){
                 if(this.token){ 
                    this.$router.push({
                        path: '/liveList',
                    })                      
                 }  else {
                    this.$router.push({
                        path: '/login',
                    })
                 }
                //this.liveshow = true;

            } else if(name === '在线客服'){
            //    window.open('https://089410.kefu.easemob.com/webim/im.html?configId=0ab2e4b7-f4e7-4b6d-8f4f-2cabb1319de0','_blank');
                // this.answershow = true;
                window.qimoChatClick();
            }
        },
        getLiveList() {
            this.$api.home.getLatelyLive({pageNum: 1, pageSize: 1}).then((data) => {
                this.configLive = data.data.list.length === 0 ? false : true
                this.liveInfo = data.data.list[0];
                if(this.liveInfo) {
                    this.islive = this.liveInfo.status == 1 ? true : false
                }
            })
        },
        // getIndexTrain() {
        //     this.$api.home.findIndexTrain().then((data) => {
        //         // data.data = null;
        //         let nodata = {
        //             name: '人工智能工程技术人员培训（2020秋季期）',
        //             trainStartTime: '2021-01-09 00:00:00',
        //             trainEndTime: '2021-02-06 23:59:59',
        //         }
        //         this.trainInfo = data.data === null || data.data === 'null' ? nodata : data.data;

        //     }) 
        // },
         findSaleGoodsPay(){
            this.$api.home.findGongxinSale().then((data) => {
               if(data.data){
                    this.trainArr = data.data;
                    // sessionStorage.setItem('goodsId', this.trainArr[0].id)
                    // if(this.trainArr[0].name.length>16){
                    //     this.trainArr[0].name = this.trainArr[0].name.substring(0,16)+'...'
                    // }
                    // if(this.trainArr[1].name.length>16){
                    //     this.trainArr[1].name = this.trainArr[1].name.substring(0,16)+'...'
                    // }
                    this.trainArr.forEach(item=>{
                        if(item.seq==1){
                            this.goodsId = item.id
                            this.goPracticeTest(this.goodsId);
                        }else{
                            this.goodsId = item.id
                            this.goPracticeTest(this.goodsId);
                        }
                    })
                    // this.goodsId = data.data.id
                    // this.goPracticeTest(this.goodsId);
                }

            }) 
        },
        getMoreExpert(val){
            let allarr = homedata.expertList;
            let orgarr = homedata.expertList.slice(0,4);
            this.expertList1 = val === 'first' ? orgarr : allarr;
            this.showall = val === 'first' ? true : false
        }
    },
        mounted() {
        this.findSaleGoodsPay();
        this.getMoreExpert('first');
        // this.getIndexTrain();
        // this.getLiveList();
        
        this.token = localStorage.getItem('token') ? localStorage.getItem('token') : null
        this.windowurl = window.location.hostname.replace(/h5/, 'pc');
    }
};
</script>
<style lang="less" scoped>
.gongxinhomepage{
    .gongxinhomepage-banner{
        .swiper-wrap{
            margin-bottom: 0px;
        }
    }
    .liveshow{
        .van-popup{
            width: 295px;
            // height: 217px;
            background: #FFFFFF;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
            border-radius: 12px;
            overflow-y: hidden;
            .livepop{
                padding: 24px;
                .poptitle{
                    text-align: center;
                    font-size: 18px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 550;
                    color: #202124;
                    padding-bottom: 18px;
                    padding-top: 10px;
                }
                .popInfo{
                    // height: 56px;       
                    font-size: 16px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    color: #202124;
                    line-height: 30px;
                    padding-bottom: 25px;
                    text-align: center;
                }
                .popbtn{
                    width: 247px;
                    height: 40px;
                    background: linear-gradient(136deg, #407DF7 0%, #416DF6 100%);
                    border-radius: 22px;
                    line-height: 40px;
                    text-align: center;
                    color: #fff;
                    font-size: 16px;
                }
            }
            
        }
    }
    .answershow{
        .van-popup{
            width: 295px;
            height: 305px;
            background: #FFFFFF;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
            border-radius: 12px;
            text-align: center;
            .answerpop{
                .answertitle{
                    padding-top: 30px;
                    font-size: 18px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 550;
                    color: #202124;
                }
                .answerImg{
                    position: relative;
                    width: 140px;
                    height: 140px;
                    margin: 18px auto 10px;
                    .smallimg{
                        position: absolute;
                        width: 14px;
                        height: 14px;
                    }
                    img{
                        width: 140px;
                        height: 140px;
                        border: 1px solid #F6F6F6;
                    }
                    .topimg{
                        top: -2px;
                        left: -2px;
                    }
                    .bottomimg{
                        bottom: -2px;
                        right: -2px;
                    }
                }
                .answerText{
                    font-size: 16px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #202124;
                    line-height: 28px;
                }
            }
        }
    }
    
}

</style>
<style scoped lang="less">
@import url("../asset/css/homepage.less");
</style>
